import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { PharmacyGroupDrug } from '../_models/pharmacy-group-drug.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { environment } from 'src/environments/environment';

@Injectable()
export class PharmacyGroupDrugService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  addPharmacyGroupDrugs(drugs, pharmacyGroupId) {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacy_groups/${pharmacyGroupId}/drugs`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<PharmacyGroupDrug>(url, { drugs }, { headers });
  }

  findPharmacyGroupDrugs(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacy_groups/${queryParams.filter.pharmacyGroupId}/drugs`;
    const pageSize = queryParams.pageSize;
    const pageIndex = queryParams.pageNumber;
    let sort = queryParams.sortField.replace(/([-_]\w)/g, (g) => g[1].toUpperCase());
    sort === 'drug' ? (sort = 'drug.drug') : sort;
    sort === 'ndc' ? (sort = 'drug.ndc') : sort;

    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    // tslint:disable-next-line:max-line-length
    const params = new HttpParams({
      fromString:
        `page=${pageIndex}&size=${pageSize}&is_active=true` +
        '&sort=' +
        sort +
        `,${queryParams.sortOrder}`,
    });
    return this.http.get<QueryResultsModel>(url, { headers, params });
  }

  updatePharmacyGroupDrug(
    _pharmacyGroupDrug: PharmacyGroupDrug,
    pharmacyGroupId: number,
  ): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacy_groups/${pharmacyGroupId}/drugs/${_pharmacyGroupDrug.id}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<PharmacyGroupDrug>(url, _pharmacyGroupDrug, { headers });
  }

  deletePharmacyGroupDrug(pharmacyGroupDrugId: number, pharmacyGroupId: number): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/pharmacy_groups/${pharmacyGroupId}/drugs/${pharmacyGroupDrugId}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete<any>(url, { headers });
  }

  searchDrugs(term: string): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/drugs`;
    const params = new HttpParams({
      fromString: 'sort=drug,asc&is_active=true&search_term=' + term,
    });
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers, params });
  }
}
